import React, { useEffect, useState } from "react";

const Input = React.forwardRef(
  (
    {
      id = "input",
      label = "none",
      type = "text",
      subType = "none",
      value,
      onChange,
      placeholder,
      state = "normal",
      alertState,
      validate,
      action,
      timerAcrion = 0,
      textAction,
      activeAction,
      pattern = "^[A-Za-z0-9 ]+[A-Za-z0-9 ]*$",
      style,
      isCheckPass,
      checkPass = "none",
      titleAction,
      disabled = false,
      cookieName = null,
      ...props
    },
    ref
  ) => {
    const [timer, setTimer] = useState(0);

    function getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) {
        return parts.pop().split(';').shift();
      }
      return null;
    }

    function getRemainingTime(cookieName) {
      const timestamp = getCookie(cookieName);
      if (!timestamp) {
        console.error("No timestamp in cookie");
        return 0;
      }

      const currentDate = new Date();
      const cookieDate = new Date(timestamp); // Очікувана дата закінчення терміну дії

      if (isNaN(cookieDate.getTime())) {
        console.error("Invalid timestamp in cookie:", timestamp);
        return 0;
      }

      // Обчислення різниці в мілісекундах
      const remainingTimeInMillis =  currentDate - cookieDate;

      if (remainingTimeInMillis <= 0) {
        console.log("Time expired", remainingTimeInMillis);
        return 0;
      }

      // Перетворюємо мілісекунди в секунди
      const remainingTimeInSeconds = timerAcrion - Math.floor(remainingTimeInMillis / 1000);

      console.log("Remaining time in seconds:", remainingTimeInSeconds);
      return remainingTimeInSeconds;
    }
    // Викликаємо функцію для оновлення часу після першого рендеру
    useEffect(() => {
      if (cookieName) {
        const initialTime = getRemainingTime(cookieName);
        console.log("Initial time:", initialTime);
        setTimer(initialTime);
      }
    }, [cookieName]);

    // Function to format the phone number
    const formatPhoneNumber = (inputValue) => {

      // delete all characters except digits
      const numbers = inputValue.replace(/\D/g, "");
      // 12 is the maximum length of the number
      const trimmed = numbers.substring(0, 12);
      const match = trimmed.match(
        /^(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})$/
      );

      if (match) {
        // if the number is valid, format it
        let formattedNumber = "";
        if (match[1]) formattedNumber += `+${match[1]}`;
        if (match[2]) formattedNumber += ` (${match[2]}`;
        if (match[3]) formattedNumber += `)-${match[3]}`;
        if (match[4]) formattedNumber += `-${match[4]}`;
        if (match[5]) formattedNumber += `-${match[5]}`;
        return formattedNumber;
      }
      return inputValue;
    };

    const handleChange = (e) => {
      let inputValue = e.target.value;
      // if the input is a phone number, format it
      if (type === "tel") {
        inputValue = formatPhoneNumber(inputValue);
      }
      // if the input has a validation function, validate it
      if (type !== "checkbox" && validate) {
        validate(inputValue);
      }
      // call the onChange function with the new value
      onChange({ ...e, target: { ...e.target, value: inputValue } });
    };

    // useEffect to call the action function when the timer reaches 0
    useEffect(() => {
      if (timer > 0) {
        setTimeout(() => {
          setTimer(timer - 1);
        }, 1000);
      }
    }, [timer]);
    const submit_action = (e) => {
      if (timer === 0) {
        action();
        setTimer(timerAcrion);
      }
    };

    // if the input is a checkbox, return a checkbox
    if (type === "checkbox") {
      value = value || false; // if value is undefined, set it to false
      return (
        <div style={style} className="checkbox-container">
          <div className="checkbox-custom">
            <input
              id={id}
              type="checkbox"
              checked={value}
              onChange={handleChange}
              ref={ref}
              {...props}
            />
            <div
              className={value ? "true" : "false"}
              onClick={() => handleChange({ target: { value: !value } })}
            >
              <i className="ri-check-line"></i>
            </div>
          </div>
          {label !== "none" && (
            <label htmlFor={id}>
              {Array.isArray(label)
                ? label.map((element, index) => (
                  <React.Fragment key={index}>{element}</React.Fragment>
                ))
                : label}
            </label>
          )}
        </div>
      );
    } else if (type === "code") {
      return (
        <div style={style} className="component-input action-button">
          {label !== "none" && <label htmlFor={id}>{label}</label>}
          <div>
            <input
              id={id}
              type="text"
              value={subType === "tel" ? value : value}
              onChange={handleChange}
              placeholder={placeholder}
              className={state}
              pattern={
                subType === "tel"
                  ? "\\+[0-9]{8,14}"
                  : pattern
              }
              ref={ref}
              {...props}
            />{" "}
            <button
              type="button"
              onClick={timer === 0 || activeAction ? () => submit_action() : null}
              className={`input__submit ${state}`}
              disabled={timer > 0 || activeAction}
              title={titleAction}
            >
              <p>
                {textAction} {timer ? `(${timer}s)` : ""}
              </p>
            </button>
          </div>

          {alertState && <p className={state}>{alertState}</p>}
        </div>
      );
    } else if (checkPass !== "none") {
      return (
        <div style={style} className="component-input action-button">
          {label !== "none" && <label htmlFor={id}>{label}</label>}
          <div>
            <input
              id={id}
              type={isCheckPass ? "text" : "password"}
              value={value}
              onChange={handleChange}
              placeholder={placeholder}
              className={state}
              pattern={pattern}
              ref={ref}
              {...props}
            />
            <button
              type="button"
              onClick={() => checkPass(!isCheckPass)}
              className={`input__submit ${state} password-button`}

            >
              <p>
                {isCheckPass ? <i className="ri-eye-off-line"></i> : <i className="ri-eye-line"></i>}

              </p>
            </button>
          </div>

          {alertState && <p className={state}>{alertState}</p>}
        </div>
      );
    } else {
      // if the input is not a checkbox, return an input
      return (
        <div style={style} className="component-input">
          {label !== "none" && <label htmlFor={id}>{label}</label>}
          <input
            id={id}
            type={type}
            value={type === "tel" ? formatPhoneNumber(value) : value}
            onChange={handleChange}
            placeholder={placeholder}
            className={state}
            pattern={
              type === "tel"
                ? "\\+[0-9]{2} \\([0-9]{3}\\)-[0-9]{3}-[0-9]{2}-[0-9]{2}"
                : pattern
            }
            // pattern={pattern}
            ref={ref}
            disabled={disabled}
            {...props}
          />
          {alertState && <p className={state}>{alertState}</p>}
        </div>
      );
    }
  }
);

export default Input;
